import styled from 'styled-components';

export {
  Container,
  LeftPanel,
  RightPanel,
  EmptyState,
  NewButton,
  FormContainer,
  FormHeader,
  FormTitle,
  Field,
  Label,
  Input,
  FormSelect,
  ButtonRow,
  SaveButton,
  DeleteButton,
  SecondaryButtonRow,
  ModalOverlay,
  ModalBox,
  ModalTitle,
  ModalText,
  ModalActions,
  ModalCancelButton,
  ModalConfirmDeleteButton,
} from '../dispositions/styled-comps';

export { ListItem } from '../bots/styled-comps';

export const ChannelListName = styled.div`
  font-weight: 500;
`;

export const ChannelListSubtext = styled.div`
  font-size: 11px;
  color: #888;
  margin-top: 2px;
`;
